if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      connectedCallback() {
  this.variantChangeUnsubscriber = subscribe(
    PUB_SUB_EVENTS.variantChange,
    this.handleVariantChange.bind(this)
  );

  this.optionValueChangeUnsubscriber = subscribe(
    PUB_SUB_EVENTS.optionValueSelectionChange,
    this.handleOptionValueSelectionChange.bind(this)
  );

  queueMicrotask(() => this.filterMediaByVariant(this.getSelectedVariant()));
}

      disconnectedCallback() {
  this.variantChangeUnsubscriber?.();
  this.optionValueChangeUnsubscriber?.();
}

      getSelectedVariant() {
        const selectedVariant = this.closest('product-info')?.querySelector(
          'variant-selects [data-selected-variant]'
        );
        if (!selectedVariant) return null;

        try {
          return JSON.parse(selectedVariant.textContent);
        } catch {
          return null;
        }
      }
handleOptionValueSelectionChange({ data: { event } }) {
  const productInfo = this.closest('product-info');
  if (!productInfo || !productInfo.contains(event.target)) return;

  window.requestAnimationFrame(() => {
    const options = Array.from(
      productInfo.querySelectorAll(
        'variant-selects input[type="radio"]:checked, variant-selects select'
      )
    )
      .map((input) =>
        input.tagName === 'SELECT'
          ? input.options[input.selectedIndex]?.text
          : input.value
      )
      .filter(Boolean);

    this.filterMediaByVariant({ options });
  });
}

      handleVariantChange({ data: { sectionId, variant } }) {
        const productInfo = this.closest('product-info');
        const currentSectionId = productInfo?.dataset.originalSection || productInfo?.dataset.section;
        if (currentSectionId && currentSectionId !== sectionId) return;

        this.filterMediaByVariant(variant);
      }

      filterMediaByVariant(variant) {
        const normalize = (value) =>
          String(value ?? '')
            .trim()
            .toLowerCase()
            .replace(/[_-]+/g, ' ')
            .replace(/\s+/g, ' ');
        const galleryItems = Array.from(this.elements.viewer.querySelectorAll('li[data-variant-color]'));
        const thumbnailItems = Array.from(
          this.elements.thumbnails?.querySelectorAll('li[data-variant-color]') || []
        );
        const mediaColors = new Set(
          galleryItems.map((item) => normalize(item.dataset.variantColor)).filter(Boolean)
        );
        const selectedColor = variant?.options?.map(normalize).find((option) => mediaColors.has(option));
        const toggleItem = (item) => {
  const mediaColor = normalize(item.dataset.variantColor);
  const shouldHide = Boolean(selectedColor && mediaColor && mediaColor !== selectedColor);

  item.hidden = shouldHide;
  if (item.matches('li[data-variant-color]')) {
  if (shouldHide) {
    item.style.setProperty('display', 'none', 'important');
  } else {
    item.style.removeProperty('display');
  }
}
 if (selectedColor && item.matches('li.product__media-item')) {
  item.classList.toggle('product__media-item--single', !shouldHide);

  if (shouldHide) {
    item.style.removeProperty('width');
    item.style.removeProperty('max-width');
  } else {
    item.style.setProperty('width', '100%');
    item.style.setProperty('max-width', '100%');
  }
}

  if (item.closest('product-modal')) {
    if (shouldHide) {
      item.style.setProperty('display', 'none', 'important');
    } else {
  item.style.setProperty('display', 'block', 'important');
}
  }
};

        galleryItems.forEach(toggleItem);
        thumbnailItems.forEach(toggleItem);

        const productInfo = this.closest('product-info');
        const modal = document.getElementById(`ProductModal-${productInfo?.dataset.section}`);
        modal?.querySelectorAll('[data-variant-color]').forEach(toggleItem);

        const visibleMedia = galleryItems.filter((item) => !item.hidden);
        const activeMedia = this.elements.viewer.querySelector('.is-active');
        if ((!activeMedia || activeMedia.hidden) && visibleMedia[0]) {
          this.setActiveMedia(visibleMedia[0].dataset.mediaId, false);
        }

        window.requestAnimationFrame(() => {
          this.elements.viewer.resetPages?.();
          this.elements.thumbnails?.resetPages?.();
          const total = this.elements.viewer.querySelector('.slider-counter--total');
          if (total) total.textContent = visibleMedia.length;
        });
      }

      onSlideChanged(event) {
        if (!event.detail.currentElement) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
